import { LucideIcon } from 'lucide-react';
import React, { useState } from 'react';
import { VideoLightbox } from './VideoLightbox';

interface PlayIconProps {
  icon: LucideIcon;
  iconColor?: string;
  size?: number;
  videoUrl: string;
  id?: string;
}

export const PlayIcon: React.FC<PlayIconProps> = ({
  icon: Icon,
  iconColor = '#7856cd',
  size = 32,
  videoUrl,
  id,
}) => {
  const [showVideoModal, setShowVideoModal] = useState(false);

  const handleClick = () => {
    setShowVideoModal(true);
  };

  return (
    <>
      <div
        id={id}
        className="relative cursor-pointer"
        onClick={handleClick}
      >
        <Icon
          className="h-6 w-6"
          style={{ color: iconColor, width: size, height: size }}
        />
      </div>
      <VideoLightbox
        videoUrl={videoUrl}
        isOpen={showVideoModal}
        onOpenChange={setShowVideoModal}
      />
    </>
  );
};
